module.exports = __webpack_public_path__ + "static/media/montserrat-latin-100-normal.a9953733.woff2";